import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
  Box,
  Container,
  Typography,
} from "@mui/material";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/theme";

const steps = [
  {
    label: "Sign up",
    subText:
      "Join Awsmo in under 2 minutes and unlock instant access to smarter cloud savings.",
    icon: <PersonAddAltOutlinedIcon fontSize="large" />,
  },
  {
    label: "Analysis",
    subText:
      "Our AI scans your cloud to spot hidden waste and reveal where you can save big.",
    icon: <SearchOutlinedIcon fontSize="large" />,
  },
  {
    label: "Start Saving",
    subText:
      "Put your cloud on autopilot, <br /> Awsmo continuously trims costs while keeping performance high.",
    icon: <VpnKeyOutlinedIcon fontSize="large" />,
  },
];

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 40,
    left: "calc(-50% + 40px)",
    right: "calc(50% + 40px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.divider,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  // backgroundColor: theme.palette.grey[400],
  backgroundColor: theme.palette.secondary.main,
  zIndex: 1,
  color: "#fff",
  width: 80,
  height: 80,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  transition: theme.transitions.create(["background-color", "box-shadow"], {
    duration: theme.transitions.duration.short,
  }),
  ...(ownerState.active && {
    backgroundColor: theme.palette.secondary.main,
    boxShadow: `0 4px 10px 0 rgba(0,0,0,.25)`,
  }),
  ...(ownerState.completed && {
    backgroundColor: theme.palette.grey[400],
    // backgroundColor: theme.palette.secondary.main,
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;
  return (
    <StepIconRoot ownerState={{ completed, active }} className={className}>
      {steps[icon - 1].icon}
    </StepIconRoot>
  );
}

export default function Steps() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ py: 8, bgcolor: "background.default" }}>
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 6 }}>
            <Typography
              variant="subtitle1"
              sx={{
                display: "inline-block",
                bgcolor: "secondary.main",
                color: "white",
                px: 2,
                py: 1,
                borderRadius: 1,
                mb: 6,
              }}
            >
              How It Works
            </Typography>
            <Typography
              variant="h3"
              sx={{ fontWeight: "bold", mb: 2, color: "primary.main" }}
            >
              Get Started in 3 Easy Steps
            </Typography>
            <Typography
              variant={{ lg: "h6", xs: "body1" }}
              color="text.secondary"
            >
              Our streamlined process makes cloud optimization simple and
              risk-free.
            </Typography>
          </Box>
          <Stepper
            alternativeLabel
            activeStep={1}
            connector={<CustomConnector />}
          >
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel StepIconComponent={CustomStepIcon}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", mt: 2, ml: 0 }}
                  >
                    {step.label}
                  </Typography>
                  <Typography
                    color="text.secondary"
                    variant="subtitle1"
                    sx={{ mt: 1, display: { lg: "flex", xs: "none" } }}
                  >
                    {step.subText}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
